export default function AiChatIcon({ className }) {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 212.68 489.56"
			aria-hidden="true"
		>
			<polygon
				fill="currentColor"
				points="212.51 0 148.57 0 148.57 148.73 64.73 148.73 64.73 0 .76 0 .76 212.64 212.51 212.64 212.51 0"
			/>
			<polygon
				fill="currentColor"
				points="212.39 341.56 212.39 277.61 .52 277.65 0 489.52 212.68 489.56 212.68 425.61 63.95 425.61 63.95 341.56 212.39 341.56"
			/>
		</svg>
	);
}